import './instrument';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app';
import './assets/styles/base.css';
import './assets/js/widget.js';

import { Capacitor } from '@capacitor/core';

const platform = Capacitor.getPlatform();
if (platform === 'android' || platform === 'ios') {
  import('./assets/styles/mobileapp.css')
    .then(() => console.log('Mobile CSS loaded'))
    .catch((err) => console.error('Failed to load mobile CSS', err));
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <App isMobile={platform === 'android' || platform === 'ios'} />
  </StrictMode>,
);
